module.exports = __webpack_public_path__ + "static/img/day_report_win.7de5f875.png";